import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { Element } from 'react-scroll';
import Waypoint from 'react-waypoint';

import { sectionType } from '../utils';

const Wrapper = styled.div`
  margin: ${p => (p.sectionId === 'custom' ? '0 0 60px' : '60px 0')};
`;

/*
 * This exists because Waypoint needs a component with an innerRef property to
 * hook in to in order to work properly.
 */
const WaypointHook = ({ children, innerRef, sectionId }) => (
  <Wrapper ref={innerRef} sectionId={sectionId}>
    {children}
  </Wrapper>
);

WaypointHook.propTypes = {
  children: PropTypes.node,
  innerRef: PropTypes.func,
  sectionId: PropTypes.string
};

class Section extends React.PureComponent {
  static propTypes = {
    onEnter: PropTypes.func.isRequired,
    section: sectionType,
    productSlug: PropTypes.string
  };

  onEnter = () => this.props.onEnter(this.props.section.id);

  /*
    The crest comparison chart was placed above the Literature section of the product sections per client request.
    This caused an issue with the scroll position when a user clicked either the technical documents button in the
    product header, or the Literature tab. The page would scroll to the crest comparison chart on the crest boiler
    and hellcat pages, and not the lit section. To fix this, we need to put the name attribute for 'lit' on the
    InnerWrapper of Literature component for those 2 pages instead of on the Element component below.
  */
  checkSlug = id => {
    if (
      id === 'lit' &&
      (this.props.productSlug === 'crest-condensing-boiler' ||
        this.props.productSlug === 'crest-with-hellcat-combustion-technology')
    ) {
      return null;
    }

    return id;
  };

  render() {
    const {
      section: { data = {}, id, view: View }
    } = this.props;

    return (
      <Waypoint
        onEnter={this.onEnter}
        topOffset="50%"
        bottomOffset="30%"
        scrollableAncestor="window"
      >
        <WaypointHook sectionId={id}>
          <Element name={this.checkSlug(id)} />
          <View {...data} />
        </WaypointHook>
      </Waypoint>
    );
  }
}

export default Section;
